import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { Store } from '@ngxs/store';
import { InitiateCall } from 'app/store/call/call.actions';
import { MatMenuTrigger } from '@angular/material/menu';
import { UntypedFormGroup } from '@angular/forms';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { CountryDataState } from 'ng2-app/store/country/country-data.state';
import { map, takeUntil } from 'rxjs/operators';
import { lastValueFrom, Subject } from 'rxjs';
import { LocaleSettingService } from 'app/services/i18n/locale-setting.service';

@Component({
  selector: 'app-direct-dial',
  templateUrl: './direct-dial.component.html',
  styleUrls: ['./direct-dial.component.scss'],
  standalone: false
})
export class DirectDialComponent implements OnInit, OnDestroy {

  @ViewChild(MatMenuTrigger, { static: true }) trigger: MatMenuTrigger;
  @ViewChild('focus', { static: true }) focusInput: ElementRef;

  value: string;
  phoneCountryCode: number | null = null;
  calling = false;
  destroyed$ = new Subject<boolean>();
  model: any = {
    phone: {
      phone: null,
      countryCode: this.localeSettingService.getDefaultLocalePhoneCode()
    }
  };
  form = new UntypedFormGroup({});
  options: FormlyFormOptions = {};
  fields: FormlyFieldConfig[] = [
    {
      key: 'phone',
      type: 'intl-phone',
      templateOptions: {
        label: 'Phone',
        attributes: {
          'data-cy': 'direct-phone-input'
        }
      }
    }
  ];

  constructor(private store: Store, private localeSettingService: LocaleSettingService) {}

  ngOnInit() {}

  async handleSubmit($event) {

    this.setPhoneCountryCode(this.form.value.phone.countryCode);

    $event.stopPropagation();
    if (this.form.invalid) {
      return;
    }

    this.calling = true;

    await lastValueFrom(
      this.store.dispatch(new InitiateCall({ borrowerId: -1, phone: `+${this.phoneCountryCode}${this.form.value.phone.phone}` })));

    this.trigger.closeMenu();
    this.calling = false;
    this.resetFormValues();
  }

  setPhoneCountryCode(phoneCountryCode: string) {
    const countryCodeIdValue = phoneCountryCode ? phoneCountryCode : '2';
    this.store.select(CountryDataState.countryFromPhoneCountyCodeId)
      .pipe(takeUntil(this.destroyed$),
        map(filterFn => filterFn(countryCodeIdValue))).subscribe((countryData) => {
      if (countryData) {
        this.phoneCountryCode = countryData.phoneCountryCode?.countryCode || null;
      }
    });
  }

  resetFormValues() {
    this.model = {
      phone: {
        phone: null,
        countryCode: 2
      }
    };
  }

  ngOnDestroy(): void {
    this.destroyed$.next(false);
  }
}
